import React, { Component } from 'react';
import styles from './shared.module.css';

export default class TitleBar extends Component {
    render() {
        return (
            <div className={styles.titleBar}>
             <div className={styles.titleArrow_container}> <div className={styles.titleArrow}></div></div>
              <p className={styles.titleBar_title}>Facility Request {(this.props.activePage!=="Home")?"› "+ this.props.activePage : null}  </p>
            </div>
        );
    }
}